export default class SmsService {

    constructor(private Restangular: any) {
        'ngInject';
    }

    public async sendInitialFpSmsForEmergencyContacts() {
        return this.Restangular
            .all('sms/emergency-contacts/send-fp-initial')
            .withHttpConfig({
                cache: false
            })
            .post();
    }

    public async enrollCentralStationSms() {
        return this.Restangular
            .all('sms/emergency-contacts/enroll')
            .withHttpConfig({
                cache: false
            })
            .post();
    }

    public async undoEnrollmentCentralStationSms() {
        return this.Restangular
            .all('sms/emergency-contacts/undo-enroll')
            .withHttpConfig({
                cache: false
            })
            .post();
    }

    public async isSmsEnabled() {
        return this.Restangular
            .all('sms')
            .one('is-enabled')
            .withHttpConfig({
                cache: false
            })
            .get();
    }
}